export default __webpack_public_path__ + "static/media/kestrel8.4dc08149.jpg";